import { useGetIsPassengerValid } from '../useGetIsPassengerValid';

/**
 * Confirm Submission is enabled when the primary passenger required fields are valid and no name
 * field (primary middle name, or any additional passenger name) exceeds its character limit.
 * Related passengers are otherwise optional.
 */
export const useGetIsFormValid = () => {
  const { isPrimaryPassengerValid, arePrimaryNamesWithinLimit, areRelatedNamesWithinLimit } = useGetIsPassengerValid();

  return isPrimaryPassengerValid && arePrimaryNamesWithinLimit && areRelatedNamesWithinLimit;
};
